var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-point"},[_c('img',{staticStyle:{"width":"auto","height":"100px"},attrs:{"src":_vm.imagePath,"alt":_vm.title}}),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }